export class LoginRequest {
    public Password: string;
    public AccountNr: string;
    public RememberMe: boolean;
    public Guid: string;
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/domain/login-request.ts